import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { getRouteQueryParam } from '@/helpers/routeQuery';
import { parseCareType } from '@/types/care_type';

export function useFavoritesRoute(itemsPerPage: number) {
  const route = useRoute();
  const router = useRouter();
  const currentPage = computed(() => {
    const value = getRouteQueryParam(route.query, 'page');
    const page = Number(value);
    return value && /^[1-9]\d*$/.test(value) && Number.isSafeInteger(page) ? page : 1;
  });
  const careType = computed(() => parseCareType(getRouteQueryParam(route.query, 'careType')));

  function queryForPage(page: number) {
    const query = { ...route.query };
    if (page > 1) query.page = String(page);
    else delete query.page;
    return query;
  }

  function applyCareTypeFilter({ value }: { value: string }): void {
    const query = queryForPage(1);
    const selected = parseCareType(value);
    if (selected) query.careType = selected.toLowerCase();
    else delete query.careType;
    router.push({ path: '/account/seeker/favorites', query });
  }

  async function correctPage(totalCount: number): Promise<void> {
    const lastPage = Math.max(1, Math.ceil(totalCount / itemsPerPage));
    const query = queryForPage(Math.min(currentPage.value, lastPage));
    if (route.query.page !== query.page) {
      await router.replace({ path: '/account/seeker/favorites', query });
    }
  }

  function handlePageChange(page: number): void {
    if (page === currentPage.value) return;

    router.push({ path: '/account/seeker/favorites', query: queryForPage(page) });
  }

  return {
    careType,
    currentPage,
    applyCareTypeFilter,
    handlePageChange,
    correctPage,
  };
}
